<div #container class="container" (scroll)="checkScrollButtons()">
  <button
    #leftButton
    class="icon-button left"
    (click)="scrollLeft()"
    aria-label="Desplazar a la izquierda el scroll de filtros">
    <span class="material-symbols-rounded">chevron_left</span>
  </button>
  <button
    #rightButton
    class="icon-button right"
    (click)="scrollRight()"
    aria-label="Desplazar a la derecha el scroll de filtros">
    <span class="material-symbols-rounded">chevron_right</span>
  </button>
  <mat-chip-listbox class="chip-list" #options>
    <ng-content></ng-content>
  </mat-chip-listbox>
</div>
